<div class="dialog-loading" *ngIf="(loading$ | async)">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{data.payment.refund ? 'Повернення' : 'Платіж'}}</div>
    <div class="dialog-close" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </div>
</div>

<div class="dialog-content scrollable">
    <div class="scroll-content-padding dialog-form df-c gap20">
        <div class="key-value grid gap10">
            <span class="key">{{data.payment.refund ? 'Платник' : 'Отримувач'}}</span>
            <span class="value">{{data.payment?.dahCounterParty?.name ? data.payment.dahCounterParty?.name : ''}}</span>

            <span class="key">Дата</span>
            <span class="value">{{data.payment.date | date: 'dd.MM.yyyy HH:mm'}}</span>

            <span class="key">{{data.payment.refund ? 'Отримувач' : 'Платник'}}</span>
            <span class="value">{{data.payment?.paymentCounterparty?.name ? data.payment.paymentCounterparty?.name : ''}}</span>

            <span class="key">Коментар</span>
            <span class="value">{{data.payment.comment}}</span>

            <span class="key">Сума</span>
            <span class="value">{{data.payment.amount | currency:'UAH': 'грн.':'0.2-2'}}</span>


            <ng-container *ngIf="!data.payment.refund && getRefundedAmount()">
                <span class="key">Повернуто</span>
                <span class="value" [ngClass]="data.payment.returned ? 'warning' : ''">
                    {{getRefundedAmount() | currency:'UAH': 'грн.':'0.2-2'}}{{data.payment.returned ? ' (повністю)' : ''}}
                </span>
            </ng-container>
        </div>

        <mat-divider class="divider"></mat-divider>

        <div class="full-width df gap10" *ngIf="data.payment.refund">
            <autocomplete-item-field label="{{'Повернення до платежу'}}"
                                     [formControl]="refundOf"
                                     [dataType]="'TRANSACTION'"
                                     [canOpenList]="true"
                                     [canOpenItem]="true"
                                     [multiline]="true"
                                     [props]="{refund: false, dahCounterParty: data.payment.dahCounterParty}"
                                     (ngModelChange)="updateContractState()"
                                     class="fFlex"
            ></autocomplete-item-field>
            <div class="df jc-c ai-c">
                <button class="delete-form-control-button" [disabled]="!refundOf?.value?.id" (click)="refundOf.reset(''); updateContractState()">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
        </div>

        <span class="hint" *ngIf="data.payment.refund && refundOf?.value?.id">Договір береться з платежу, який повертається.</span>

        <div class="full-width df gap10">
            <div style="padding-top: 12px" (click)="fillByAct()" *ngIf="!data.payment.refund"
                 matTooltip="Знайти договір за номером акту"
                 matTooltipClass="tooltip"
            >
                <mat-icon class="primary-icon">find_in_page</mat-icon>
            </div>
            <autocomplete-item-field label="{{'Договір'}}"
                                     [formControl]="contract"
                                     [dataType]="'CONTRACT'"
                                     [canOpenList]="true"
                                     [canOpenItem]="true"
                                     [canEditItem]="true"
                                     [multiline]="true"
                                     [props]="{dahCounterParty: data.payment.dahCounterParty}"
                                     class="fFlex"
            ></autocomplete-item-field>
            <div class="df jc-c ai-c">
                <button class="delete-form-control-button" [disabled]="!contract?.value?.id" (click)="contract.reset()">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
        </div>

        <div class="df-c gap10" *ngIf="!data.payment.refund">
            <div class="df jc-sb ai-c gap15">
                <b>Рознесено за документами</b>
                <mat-divider class="grow"></mat-divider>
            </div>

            <span *ngIf="!data.payment.payments?.length">Платіж ще не рознесено</span>

            <div class="df gap20 jc-sb" *ngFor="let item of data.payment.payments">
                <span class="grow">{{item.act?.name}}</span>
                <span>{{item.amount | currency:'UAH': 'грн.':'0.2-2'}}</span>
            </div>
        </div>

        <div class="df-c gap10" *ngIf="!data.payment.refund">
            <div class="df jc-sb ai-c gap15">
                <b>Повернення цього платежу</b>
                <mat-divider class="grow"></mat-divider>
            </div>

            <div class="full-width df gap10">
                <autocomplete-item-field label="{{'Додати повернення'}}"
                                         [formControl]="refundToAdd"
                                         [dataType]="'TRANSACTION'"
                                         [canOpenList]="true"
                                         [canOpenItem]="false"
                                         [multiline]="true"
                                         [props]="{refund: true, dahCounterParty: data.payment.dahCounterParty}"
                                         class="fFlex"
                ></autocomplete-item-field>
                <div class="df jc-c ai-c">
                    <button class="delete-form-control-button" [disabled]="!refundToAdd?.value?.id" (click)="addRefund()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

            <span *ngIf="!refunds.length">Повернень немає</span>

            <div class="df gap20 jc-sb ai-c" *ngFor="let item of refunds">
                <span class="grow">{{item.name}}</span>
                <button class="delete-form-control-button" (click)="removeRefund(item.id!)">
                    <mat-icon>delete_outline</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="buttons-row df jc-sb ai-c gap20">
    <div class="key-value grid gap10">
        <ng-container *ngIf="getUnhandled()">
            <span class="key">{{data.payment.refund ? 'Не привʼязано до договору' : 'Нерознесено'}}</span>
            <span class="value warning">{{getUnhandled() | currency:'UAH': 'грн.':'0.2-2'}}</span>
        </ng-container>
    </div>
    <div class="df jc-e ai-c gap20">
        <button class="default-button apply-button-flat" (click)="submitForm(false)"
                [disabled]="contract.invalid && (loading$ | async) === false">
            {{'common.save' | translate}}
        </button>
        <button class="default-button apply-button" (click)="submitForm(true)" [disabled]="contract.invalid && (loading$ | async) === false">
            {{'common.saveAndClose' | translate}}
        </button>
    </div>
</div>
